function generateDateTime () {
  let currentDate = new Date()
  return (
    currentDate.getDate().toString() +
    (currentDate.getMonth() + 1).toString() +
    currentDate.getFullYear().toString() + '_' +
    currentDate.getHours() +
    currentDate.getMinutes() +
    currentDate.getSeconds()
  )
}

export default generateDateTime



// WEBPACK FOOTER //
// ./client/utils/generateDateTime.js